import { useCurrentService } from "playground/cms/hooks/useCurrentService";
import { useData } from "state/hooks";

export function useCurrentTheme() {
    const service = useCurrentService();
    return useData({ type: "console.themes", id: service?.theme });
}
